import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  clearIndividualCustomer,
  getCustomerById,
  getLast5TransactionCustomer,
} from '../../redux/actions/customer';
import CustomErrorView from '../../components/CustomErrorView';
import CustomDashboardLoader from '../../components/CustomDashboardLoader';
import CustomerDescriptionCard from '../../components/CustomerDescriptionCard';
import CustomerDetailHeader from '../../components/CustomerDetailHeader';

import CustomerTransactionDetail from './CustomerTransactionDetail';

function CustomerDetail({ match, history }) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  // const [isTransactionLoading, setIsTransactionLoading] = useState(false);
  const [showErrPage, setShowErrPage] = useState(false);
  const transactionContainer = useRef(null);
  const individualCustomer = useSelector(
    (state) => state.customer.individualCustomer
  );
  // const last5Trans = useSelector((state) => state.customer.last5Transactions);

  const handleSuccess = () => {
    setIsLoading(false);
  };
  const handleFailure = () => {
    setIsLoading(false);
    setShowErrPage(true);
  };
  useEffect(() => {
    const someId = match.params?.id;
    if (!someId) {
      setShowErrPage(true);
    } else {
      setIsLoading(true);
      // setIsTransactionLoading(true);
      dispatch(getCustomerById(someId, handleSuccess, handleFailure));
      // dispatch(getLast5TransactionCustomer(someId)).then(() =>
      //   setIsTransactionLoading(false)
      // );
    }
    return () => {
      dispatch(clearIndividualCustomer());
    };
  }, []);

  useEffect(() => {
    if (history?.location?.pathname.includes('transactions')) {
      transactionContainer.current.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, [individualCustomer]);

  if (showErrPage) {
    return <CustomErrorView />;
  } else {
    return (
      <div>
        {isLoading ? (
          <CustomDashboardLoader />
        ) : (
          <div className='bg-soft'>
            <CustomerDetailHeader customerData={individualCustomer} />
            <CustomerDescriptionCard customerData={individualCustomer} />

            <CustomerTransactionDetail />
          </div>
        )}
        <div ref={transactionContainer} />
      </div>
    );
  }
}

export default CustomerDetail;
{
  /* <div>
      <section className="bg-soft">
        <Container>
          <Row>
              <div
                className="bg-white shadow-soft border rounded border-light p-4 p-lg-5"
                style={{ width: "100%" }}
              >
                <Col xs={6} md={6}>
                  <h3>Customer Detail</h3>
                </Col>
                <Col xs={6} md={6}>
                  <Button
                    variant="danger"
                    onClick={() => {}}
                    disabled={isSubmitting}
                  >
                    {isSubmitting === true ? (
                      <Spinner animation="border" />
                    ) : (
                      "Delete Customer"
                    )}
                  </Button>
                </Col>
                {/* <div
                  className="d-flex justify-content-between"
                  style={{ width: "100%", alignItems: "center" }}
                ></div> */
}
//           </div>
//       </Row>
//     </Container>
//   </section>
// </div> */}

{
  /* <Container>
  <Accordion defaultActiveKey={1}>
    <Accordion.Item eventKey='1'>
      <Accordion.Header>View Transaction</Accordion.Header>

      <Accordion.Body>
        {isTransactionLoading ? (
          <div className='d-flex justify-content-center'>
            <Spinner animation='border' />
          </div>
        ) : (
          <>
            <div className='d-flex justify-content-between align-items-center'>
              <h5>Last 5 Transactions</h5>

              <Button
                variant='primary'
                onClick={() => {
                  history.push(
                    `/customers/transaction/detail/${individualCustomer.customerId}`
                  );
                }}
              >
                View More
              </Button>
            </div>
            {last5Trans.map((item) => (
              <div key={item.id}>
                <TransactionView
                  amount={item.amount}
                  type={item.transactionType}
                  date={item.createdDate}
                  batchId={item.batchId}
                  status={item.transactionStatus}
                  collectorName={item.collectorName}
                />
              </div>
            ))}
          </>
        )}
      </Accordion.Body>
    </Accordion.Item>
  </Accordion>
</Container>; */
}
